import React from 'react';
import type { IPriceRow } from '../../types';
import { StyledOurChoicePriceRow } from './styles';

export const OurChoicePriceRow = (props: IPriceRow) => {
  const { item, index } = props;

  return <StyledOurChoicePriceRow item={item} index={index} />;
};
